import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.find.js";
import KivaProxy from '@/utils/kivaProxy/src';
import moment from 'moment';
import { CurrencyTransformer } from '@/transformers/CurrencyTransformer';
import { LOCALES, CURRENCIES, LANGUAGES, TIME_ZONES, TIME_ENTRIES, CRM_CURRENCIES, PROFILES, PREFERENCES, FAVORITES, GROUPS, INBOX_PREFERENCES, ACTIVITY_STATUS, MY_ACTIVITY_STATUS } from './mutation-types';
import { TimezoneTransformer } from '@/transformers/TimezoneTransformer';
import { LanguageTransformer } from '@/transformers/LanguageTransformer';
import { LocaleTransformer } from '@/transformers/LocaleTransformer';
import { CrmCurrencyTransformer } from '@/transformers/CrmCurrencyTransformer';
import { ProfilesTransformer } from '@/transformers/ProfilesTransformer';
import { preferencesModel } from '@/models/preferencesModel';
import { PreferencesTransformer } from '@/transformers/PreferencesTransformer';
import { GroupTransformer } from '@/transformers/GroupTransformer';
import { InboxPreferencesTransformer } from '@/transformers/InboxPreferencesTransformer';
export default {
  getCurrencies: function getCurrencies(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/account/currency',
        driver: 'base'
      }).all().then(function (response) {
        var currencies = CurrencyTransformer.fetchCollection(response.records);
        commit(CURRENCIES, currencies);
        resolve(currencies);
      }).catch(reject);
    });
  },
  getCrmCurrencies: function getCrmCurrencies(_ref2) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'acc/currency'
      }).setFields(['para_birimi_id', 'currency_name', 'rate', 'default', 'record_id']).all().then(function (response) {
        var crmCurrencies = CrmCurrencyTransformer.fetchCollection(response.records);
        commit(CRM_CURRENCIES, crmCurrencies);
        resolve();
      }).catch(reject);
    });
  },
  getActiveTimeEntry: function getActiveTimeEntry(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, rootState;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref3.commit, rootState = _ref3.rootState;
            _context.next = 3;
            return new Promise(function (resolve, reject) {
              new KivaProxy({
                endpoint: 'act/time_entry'
              }).setFilters({
                draft: ["NOT EMPTY"],
                record_owner: ["=", rootState.users.CURRENT_USER.userId]
              }).setFields(["duration", "event", "draft", "paused", "project", "thread", "account_name", "hours", "minutes", "duration_formatted", "task", "description", "start_date", "record_owner", "created_on", "last_modified_on", "created_by"]).all().then(function (response) {
                var draft = response.records[0];
                if (draft) {
                  var _rootState$tasks$time;
                  rootState.tasks.timeCounter = (_rootState$tasks$time = {
                    time: draft.duration,
                    storage: draft.duration,
                    task: draft.task ? draft.task.value : null,
                    thread: draft.thread ? draft.thread.value : null,
                    event: draft.event ? draft.event.value : null,
                    record_id: draft.task,
                    id: draft.id,
                    isRunning: draft.paused ? true : false,
                    description: '',
                    start: moment(),
                    project: draft.project ? draft.project.value : null,
                    account_name: draft.account_name ? draft.account_name.value : null,
                    // section: drat,
                    subject: draft.subject,
                    time_show: '00:00',
                    checked: true
                  }, _defineProperty(_rootState$tasks$time, "subject", draft.task ? draft.task.label : draft.thread ? draft.thread.label : draft.event ? draft.event.label : null), _defineProperty(_rootState$tasks$time, "record_id", draft.task ? draft.task.value : draft.thread ? draft.thread.value : draft.event ? draft.event.value : null), _defineProperty(_rootState$tasks$time, "uniq", draft.task ? 'TASK_' + draft.task.value : draft.thread ? 'THREAD_' + draft.thread.value : draft.event ? 'EVENT_' + draft.event.value : ''), _rootState$tasks$time);
                  if (draft.paused) {
                    rootState.tasks.timeCounter.time = moment().diff(moment(draft.last_modified_on), "seconds") + draft.duration;
                    rootState.tasks.timeCounter.storage = rootState.tasks.timeCounter.time;
                    rootState.tasks.timeCounter.start = moment();
                  }
                  rootState.tasks.timeCounter.time_show = moment("1900-01-01 00:00:00").add(rootState.tasks.timeCounter.time, "seconds").format("HH:mm:ss");
                  console.log("Added", rootState.tasks.timeCounter);
                  var t = JSON.stringify(rootState.tasks.timeCounter);

                  // window.localStorage.setItem("timeCounter", t);
                } else {
                  // console.log("actin 2", t)
                  var c = window.localStorage.getItem("timeCounter");
                  var newTimeCounter = {
                    isRunning: false,
                    start: moment(),
                    time: 0,
                    storage: 0,
                    checked: true,
                    time_show: '00:00',
                    thread: null,
                    task: null,
                    record_id: null,
                    uniq: null
                  };
                  if (c && c.charAt(0) == "{") {
                    var carr = JSON.parse(c);
                    if (!carr.record_id) {
                      newTimeCounter = carr;
                    }
                  }
                  var _t = JSON.stringify(newTimeCounter);
                  window.localStorage.setItem("timeCounter", _t);
                }
                commit(TIME_ENTRIES, response.records);
                rootState.tasks.timeCounter.start = moment();
                rootState.tasks.timeCounter.time_show = '00:00';
                rootState.tasks.timeCounter.checked = true;
                resolve(response.records);
              }).catch(function (err) {
                rootState.tasks.timeCounter.start = moment();
                rootState.tasks.timeCounter.time_show = '00:00';
                rootState.tasks.timeCounter.checked = true;
                reject;
              }).finally(function () {
                rootState.tasks.timeCounter.checked = true;
              });
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  getTimezones: function getTimezones(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/account/time_zone',
        driver: 'base'
      }).all().then(function (response) {
        var timezones = TimezoneTransformer.fetchCollection(response.records);
        commit(TIME_ZONES, timezones);
        resolve(timezones);
      }).catch(reject);
    });
  },
  getLanguages: function getLanguages(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/account/language',
        driver: 'base'
      }).all().then(function (response) {
        var languages = LanguageTransformer.fetchCollection(response.records);
        commit(LANGUAGES, languages);
        resolve(languages);
      }).catch(reject);
    });
  },
  getCountryLocales: function getCountryLocales(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/account/locale',
        driver: 'base'
      }).all().then(function (response) {
        var locales = LocaleTransformer.fetchCollection(response.records);
        commit(LOCALES, locales);
        resolve(locales);
      }).catch(reject);
    });
  },
  getProfiles: function getProfiles(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/user/profile',
        driver: 'base'
      }).all().then(function (response) {
        var profiles = ProfilesTransformer.fetchCollection(response.records);
        commit(PROFILES, profiles);
        resolve();
      });
    });
  },
  getActivityStatus: function getActivityStatus(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'data/hr/activity_status',
        driver: 'base'
      }).all().then(function (response) {
        commit(ACTIVITY_STATUS, response.records);
        resolve();
      }).catch(reject);
    });
  },
  changeActivityStatus: function changeActivityStatus(_ref9, data) {
    var commit = _ref9.commit,
      state = _ref9.state,
      rootState = _ref9.rootState;
    // console.log("data",data)
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'data/hr/employee',
        driver: 'base'
      }).submit('patch', 'data/hr/employee', {
        records: [{
          activity_status: data.record_id,
          record_owner: data.me.value,
          record_id: data.me.hr_employee_id
        }]
      }).then(function (response) {
        var st = state.ACTIVITY_STATUS.find(function (k) {
          return k.record_id == data.record_id;
        });
        rootState.users.MY_ACTIVITY_STATUS = st;
        resolve();
      }).catch(reject);
    });
  },
  getPreferences: function getPreferences(_ref10) {
    var commit = _ref10.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/account/preferences',
        driver: 'base'
      }).all().then(function (response) {
        commit(PREFERENCES, preferencesModel(PreferencesTransformer.fetch(response)));
        resolve();
      }).catch(reject);
    });
  },
  getGroups: function getGroups(_ref11) {
    var commit = _ref11.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/group',
        driver: 'base'
      }).all().then(function (response) {
        commit(GROUPS, GroupTransformer.fetchCollection(response.records));
        resolve();
      });
    });
  },
  getInboxPreferences: function getInboxPreferences(_ref12) {
    var commit = _ref12.commit;
    return new Promise(function (resolve, reject) {
      new KivaProxy({
        endpoint: 'kvc/inbox/preferences',
        driver: 'base'
      }).all().then(function (response) {
        commit(INBOX_PREFERENCES, InboxPreferencesTransformer.fetch(response.data));
        resolve();
      });
    });
  }
};